import { render, staticRenderFns } from "./dash-right-media-item.vue?vue&type=template&id=2bc8605e&scoped=true"
import script from "./dash-right-media-item.vue?vue&type=script&lang=js"
export * from "./dash-right-media-item.vue?vue&type=script&lang=js"
import style0 from "./dash-right-media-item.vue?vue&type=style&index=0&id=2bc8605e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc8605e",
  null
  
)

export default component.exports